export class JWTHelper {
  // Prototype methods
  public static decodePayload(token: string) {
    try {
      // Validação básica do token
      if (!token || typeof token !== "string") {
        throw new Error("Token inválido: deve ser uma string não vazia");
      }

      const parts = token.split(".");
      if (parts.length !== 3) {
        throw new Error("JWT inválido: formato deve ser xxx.yyy.zzz");
      }

      const base64Url = parts[1];
      if (!base64Url) {
        throw new Error("JWT inválido: payload ausente");
      }

      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

      let decodedString: string;
      try {
        decodedString = atob(base64);
      } catch (error) {
        throw new Error("JWT inválido: payload não é base64 válido");
      }

      const json = decodeURIComponent(
        decodedString
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join(""),
      );

      try {
        return JSON.parse(json);
      } catch (error) {
        throw new Error("JWT inválido: payload não é JSON válido");
      }
    } catch (error) {
      // Re-lança o erro com contexto adicional
      if (error instanceof Error) {
        console.error("Erro ao decodificar JWT:", error.message);
        throw error;
      }
      throw new Error("Erro desconhecido ao decodificar JWT");
    }
  }
}
